import { render, staticRenderFns } from "./InvitePanel.vue?vue&type=template&id=0b379867&scoped=true"
import script from "./InvitePanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InvitePanel.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InvitePanel.vue?vue&type=style&index=0&id=0b379867&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b379867",
  null
  
)

export default component.exports